import { render, staticRenderFns } from "./cardCategories.vue?vue&type=template&id=dc67daac&scoped=true&"
import script from "./cardCategories.vue?vue&type=script&lang=js&"
export * from "./cardCategories.vue?vue&type=script&lang=js&"
import style0 from "./cardCategories.vue?vue&type=style&index=0&id=dc67daac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc67daac",
  null
  
)

component.options.__file = "cardCategories.vue"
export default component.exports